import { defineContext } from '@nzyme/vue-utils/context.js';
import { useIntersectionObserver } from '@nzyme/vue-utils/useIntersectionObserver.js';

export interface ChatEventContainerContextOptions {
    onVisible: (eventIndex: number) => void;
}

export const ChatEventContainerContext = defineContext(
    'ChatEventContainerContext',
    (options: ChatEventContainerContextOptions) => {
        return useIntersectionObserver({
            onVisible: el => {
                const seqAttr = el.getAttribute('data-seq');
                if (seqAttr == null) {
                    return;
                }

                const seq = Number.parseInt(seqAttr, 10);
                if (!Number.isNaN(seq)) {
                    options.onVisible(seq);
                }
            },
        });
    },
);
